import React from "react";
import { Flex } from "theme-ui";

class HorizontalBox extends React.PureComponent {

    render() {
        const { contribType, data } = this.props;
        let value = 0;
        const maxValue = data.status.total;
        switch (contribType) {
            case "Experimental":
                value = data.status.experimental;
                break;

            case "Beta":
                value = data.status.beta;
                break;

            case "Production":
                value = data.status.production;
                break;

            default:
                break;
        }
        const ratio = Math.round((value / maxValue) * 100);
        let className;
        if (value === 0) {
            className = "none";
        } else if (value > 0 && ratio <= 25) {
            className = "red";
        } else if (value === maxValue) {
            className = "green";
        } else {
            className = "orange";
        }

        return (
            <Flex className={`horizontal-box ${className}`} sx={{ justifyContent: "center" }}>
                {value}/{maxValue}-{ratio}%
            </Flex>
        );
    }
}

export default HorizontalBox;
